export interface TourStep {
  id: string;
  type: "modal" | "spotlight";
  target?: string;
  title: string;
  description: string;
  tagline?: string;
}

export const SELECTOR_STEPS: TourStep[] = [
  {
    id: "welcome",
    type: "modal",
    title: "Welcome to Resume Flow AI! 🚀",
    description:
      "Let us give you a quick tour of everything you can do here. Build resumes faster, optimize for ATS, and track your applications — all in one place.",
    tagline: "Apply faster. Learn more.",
  },
  {
    id: "start-fresh",
    type: "spotlight",
    target: '[data-tour="start-fresh"]',
    title: "Start Fresh",
    description:
      "Build your resume from scratch using our guided form with real-time preview. Great if you're starting new.",
  },
  {
    id: "import-resume",
    type: "spotlight",
    target: '[data-tour="import-resume"]',
    title: "Import Your Resume",
    description:
      "Already have a resume? Upload a file OR simply copy-paste your content — no need to dig through desktop folders. We'll parse and structure it instantly.",
  },
  {
    id: "tailor-job",
    type: "spotlight",
    target: '[data-tour="tailor-job"]',
    title: "Tailor for a Specific Job",
    description:
      "Paste a job description along with your resume. Our AI creates a version perfectly tailored for that role.",
  },
];

export const BUILDER_STEPS: TourStep[] = [
  {
    id: "form-tabs",
    type: "spotlight",
    target: '[data-tour="form-tabs"]',
    title: "Resume Sections",
    description:
      "Fill in each section — personal info, summary, skills, experience, education, and custom sections. Drag the tabs to reorder how they appear on your resume.",
  },
  {
    id: "section-controls",
    type: "spotlight",
    target: '[data-tour="section-controls"]',
    title: "Section Visibility & Saved Links",
    description:
      "Toggle sections on/off for different applications. Use Saved Links to store your LinkedIn, GitHub, and portfolio URLs for one-click insertion.",
  },
  {
    id: "live-preview",
    type: "spotlight",
    target: '[data-tour="live-preview"]',
    title: "Live Preview",
    description:
      "Your resume updates in real-time as you type. What you see here is exactly what gets exported.",
  },
  {
    id: "optimize-btn",
    type: "spotlight",
    target: '[data-tour="optimize-btn"]',
    title: "ATS Score & AI Optimization",
    description:
      "Get a live ATS compatibility score. Hit this button to let AI automatically improve your resume for applicant tracking systems. Aim for 80%+.",
  },
  {
    id: "file-naming",
    type: "spotlight",
    target: '[data-tour="file-naming"]',
    title: "Smart File Naming",
    description:
      'Set your role, company, and name. Downloads are automatically named like "SoftwareEngineer_Google_JohnDoe.pdf" — no more renaming files.',
  },
  {
    id: "save-btn",
    type: "spotlight",
    target: '[data-tour="save-btn"]',
    title: "Save Multiple Versions",
    description:
      "Save different resume versions to your account. Access and update them anytime from your Saved Resumes page.",
  },
  {
    id: "export-btns",
    type: "spotlight",
    target: '[data-tour="export-btns"]',
    title: "Export Your Resume",
    description:
      "Download as PDF or DOCX, or copy as plain text. All exports are ATS-optimized and ready to submit.",
  },
  {
    id: "job-tracker",
    type: "spotlight",
    target: '[data-tour="job-tracker-nav"]',
    title: "Job Application Tracker 📋",
    description:
      "Use this tracker to log every application, update statuses, and keep your entire job hunt organized in one place.",
  },
  {
    id: "finish",
    type: "modal",
    title: "You're All Set! 🎉",
    description:
      "Visit your Applications Dashboard to track job applications, manage saved resumes, and monitor your progress. You can replay this tour anytime from the footer.",
    tagline: "Apply faster. Land more.",
  },
];
